<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('owner.owners') }}</router-link> /
            <span class="color-main">{{ $t('owner.addOwner') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('owner.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('owner.addOwner') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addOwner" ref="form" v-model="valid">
              <div class="flex-group-me mb-4">
                <div class="profile-img-cont">
                  <img :src="profileImg" alt="" class="profileImg" />
                  <input
                    name="image"
                    type="file"
                    id="imageInput"
                    hidden
                    accept="image/*"
                    @change="uploadImage"
                  />
                  <label for="imageInput" class="labelImg">
                    <i class="fa-regular fa-pen-to-square"></i>
                  </label>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('owner.nameAr') }}</h6>
                <v-text-field
                  v-model="nameAr"
                  @input="preventLeadingSpace('nameAr', $event)"
                  type="text"
                  name="name[ar]"
                  :rules="defaultRoles"
                  :placeholder="$t('owner.nameArPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('owner.nameEn') }}</h6>
                <v-text-field
                  v-model="nameEn"
                  @input="preventLeadingSpace('nameEn', $event)"
                  type="text"
                  name="name[en]"
                  :rules="defaultRoles"
                  :placeholder="$t('owner.nameEnPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1 tel-input-me">
                <h6 class="mb-2 font14">{{ $t('owner.phone2') }}</h6>
                <v-text-field
                  v-model="phone"
                  name="phone"
                  @input="checkPhoneValidation"
                  type="number"
                  min="0"
                  :placeholder="$t('owner.phonePlaceholder')"
                ></v-text-field>
                <div class="drop-countries">
                  <Dropdown
                    v-model="selectedCountry"
                    :options="countries"
                    optionLabel="name"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value" class="flex-group-me">
                        <img
                          :alt="slotProps.value.label"
                          :src="slotProps.value.image"
                          :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.value.key }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <div class="flex-group-me">
                        <img
                          :alt="slotProps.option.label"
                          :src="slotProps.option.image"
                          :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.option.key }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('owner.email') }}</h6>
                <v-text-field
                  v-model="email"
                  @input="preventLeadingSpace('email', $event)"
                  type="text"
                  name="email"
                  :rules="defaultRoles"
                  :placeholder="$t('owner.emailPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1 mb-4">
                <h6 class="mb-2 font14">{{ $t('owner.property') }}</h6>
                <MultiSelect
                  v-model="selectedDepart"
                  display="chip"
                  :options="departs"
                  optionLabel="name"
                  :placeholder="$t('owner.propertyPlaceholder')"
                  :maxSelectedLabels="20"
                  class="w-full md:w-20rem"
                />
              </div>

              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('owner.password') }}</h6>
                <v-text-field
                  v-model="password"
                  name="password"
                  type="password"
                  :rules="passwordRoles"
                  :placeholder="$t('owner.passwordPlaceholder')"
                ></v-text-field>
                <div
                  class="absLeft pointer-click"
                  @click="toogleEyeIcon($event)"
                >
                  <div class="normalEye">
                    <i class="fa-regular fa-eye"></i>
                  </div>
                  <div class="slashedEye">
                    <i class="fa-regular fa-eye-slash"></i>
                  </div>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('owner.confirmPassword') }}</h6>
                <v-text-field
                  v-model="confirmPassword"
                  name="password_confirmation"
                  type="password"
                  :rules="confirmRules"
                  :placeholder="$t('owner.confirmPasswordPlaceholder')"
                ></v-text-field>
                <div
                  class="absLeft pointer-click"
                  @click="toogleEyeIcon($event)"
                >
                  <div class="normalEye">
                    <i class="fa-regular fa-eye"></i>
                  </div>
                  <div class="slashedEye">
                    <i class="fa-regular fa-eye-slash"></i>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('owner.send') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('owner.sending') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>
    <!-- success modal  -->
    <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        {{ $t('owner.ownerAddedSuccess') }}
      </h6>
      <div class="flex-group-me mb-2">
        <router-link to="/ownersView" class="main-btn lg up">
          {{ $t('owner.ownersList') }}
        </router-link>
        <router-link to="/" class="main-btn lg up trans">
          الرئيسية
        </router-link>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import Dialog from "primevue/dialog";
import { useI18n } from "vue-i18n";

import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const { t } = useI18n();

// reactive state
const form = ref(null);
const disabled = ref(false);
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('owner.fieldRequired');
  },
]);
const showSuccess = ref(false);
const confirmPassword = ref("");
const password = ref("");
const profileImg = ref(require("../assets/imgs/solia.jpg"));

const selectedDepart = ref(null);
const departs = ref([]);

const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "https://backend.maak-lancer.com/public/storage/images/countries/1701785725_8987.png",
});
const countries = ref([]);

const valid = ref(false);

// Add reactive references for form fields
const nameAr = ref("");
const nameEn = ref("");
const email = ref("");
const phone = ref("");

// functions to prevent leading spaces
function preventLeadingSpace(field, event) {
  const value = event.target.value;
  // Remove leading spaces
  const trimmedValue = value.replace(/^\s+/, '');
  // Update the field value
  if (field === 'nameAr') nameAr.value = trimmedValue;
  if (field === 'nameEn') nameEn.value = trimmedValue;
  if (field === 'email') email.value = trimmedValue;
}

// functions
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
  });
}
function getBuildings() {
  axios
    .get("/manager/buildings", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      departs.value = response.data.data;
    });
}
function addOwnerReal() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  if (selectedCountry.value) {
    fd.append("country_code", Number(selectedCountry.value.key));
  }

  if (selectedDepart.value) {
    for (let i = 0; i < selectedDepart.value.length; i++) {
      fd.append(`buildings[${i}]`, selectedDepart.value[i].id);
    }
  }

  axios
    .post("/manager/add-owner", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showSuccess.value = true;
        setTimeout(function () {
          router.push("/ownersView");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

// addBuilding
function addOwner() {
  if (valid.value) {
    addOwnerReal();
  } else {
    scrollToDanger();
  }
}

function toogleEyeIcon(event) {
  console.log(event.currentTarget);
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}

function uploadImage(e) {
  const file = e.target.files[0];
  if (e.target.files[0]) {
    profileImg.value = URL.createObjectURL(file);
  } else {
    profileImg.value = require("../assets/imgs/natural-marble-pattern-background.png");
  }
}
// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {
  getCountries();
  getBuildings();
});
</script>
